export default __webpack_public_path__ + "static/media/question_purple.35ba0c41.svg";